import type { CountdownProps } from 'components/Countdown';
import { Countdown } from 'components/Countdown';
import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ScTimer } from './styled';

const SECONDS_IN_DAY = 86_400;
const SECONDS_IN_HOUR = 3600;

export const TimerLabel: FC<Pick<CountdownProps, 'timeLeft'>> = ({
  timeLeft,
}) => {
  const { t } = useTranslation();

  const isDaysShown = useMemo(() => timeLeft > SECONDS_IN_DAY, [timeLeft]);
  const isHoursShown = useMemo(() => timeLeft > SECONDS_IN_HOUR, [timeLeft]);

  return (
    <Countdown timeLeft={timeLeft < 0 ? 0 : timeLeft}>
      {({ days, hours, minutes, seconds }) => (
        <ScTimer className="timer">
          {isDaysShown && (
            <>
              <span>
                {days}
                {t('timer.dd')[0]}
              </span>
              <span>:</span>
            </>
          )}
          {isHoursShown && (
            <>
              <span>
                {hours}
                {t('timer.hh')[0]}
              </span>
              <span>:</span>
            </>
          )}
          <span>
            {minutes}
            {t('timer.mm')[0]}
          </span>

          {!isDaysShown && (
            <>
              <span>:</span>
              <span>
                {seconds}
                {t('timer.ss')[0]}
              </span>
            </>
          )}
        </ScTimer>
      )}
    </Countdown>
  );
};
